import { render, staticRenderFns } from "./GeneralBanner.vue?vue&type=template&id=86007da4&scoped=true"
import script from "./GeneralBanner.vue?vue&type=script&lang=js"
export * from "./GeneralBanner.vue?vue&type=script&lang=js"
import style0 from "./GeneralBanner.vue?vue&type=style&index=0&id=86007da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86007da4",
  null
  
)

export default component.exports